import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getIsUngatedForSeats } from 'pricing-pages-lib/utils/gatingUtils';
import { FREE } from 'self-service-api/constants/ProductLevels';
import { AllProductLines } from 'self-service-api/constants/ProductLines';
import styled from 'styled-components';
import { ProductLinePageIcons } from 'ui-addon-upgrades/_core/productPage/ProductPageIcons';
import UIImage from 'UIComponents/image/UIImage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIList from 'UIComponents/list/UIList';
import { ProductLevelAndProductLineToSuiteBOTranslationKeyMap, ProductLevelToSuiteBOHeaderTranslationKeyMap } from '../../../constants/BusinessObjectivesTranslationKeys';
import { usePricingLibSelector } from '../../../selectors/SelectorUtils';
import { Section } from '../MerchCardSharedComponents';
import SuiteBusinessObjectivesSubtext from './SuiteBusinessObjectivesSubtext';
const StyledDiv = styled.div.withConfig({
  displayName: "SuiteBusinessObjectives__StyledDiv",
  componentId: "sc-8hvfj1-0"
})(["height:", ";margin-bottom:16px;"], ({
  addSpacing
}) => addSpacing ? '17px' : 'auto');

const SuiteBusinessObjectives = ({
  productLevel,
  commonStyles,
  addSpacing = false
}) => {
  const isSeatsRedesignUngated = usePricingLibSelector(getIsUngatedForSeats); // In order for the grid to work, we need this to remain enclosed in a Fragment and not a div.
  // Children of the display grid item must get the grid-start attributes directly

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Section, {
      className: "p-top-8",
      style: Object.assign({
        gridRowStart: 8
      }, commonStyles),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: ProductLevelToSuiteBOHeaderTranslationKeyMap[productLevel]
      })
    }), /*#__PURE__*/_jsx(Section, {
      className: "p-bottom-6",
      style: Object.assign({
        gridRowStart: 9,
        lineHeight: 'normal',
        fontSize: '13px'
      }, commonStyles),
      children: /*#__PURE__*/_jsx(UIList, {
        children: AllProductLines.map(localProductLine => {
          return /*#__PURE__*/_jsxs(UIFlex, {
            className: "m-y-2",
            children: [/*#__PURE__*/_jsx(UIImage, {
              className: "display-inline m-right-3",
              src: ProductLinePageIcons[localProductLine]
            }), /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("div", {
                style: productLevel !== FREE && isSeatsRedesignUngated ? {
                  fontWeight: 600
                } : {},
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: ProductLevelAndProductLineToSuiteBOTranslationKeyMap[productLevel][localProductLine].title
                })
              }), isSeatsRedesignUngated ? /*#__PURE__*/_jsx(StyledDiv, {
                children: /*#__PURE__*/_jsx(SuiteBusinessObjectivesSubtext, {
                  productLevel: productLevel,
                  productLine: localProductLine
                })
              }) : /*#__PURE__*/_jsx(StyledDiv, {
                addSpacing: addSpacing,
                children: /*#__PURE__*/_jsx(SuiteBusinessObjectivesSubtext, {
                  productLevel: productLevel,
                  productLine: localProductLine
                })
              })]
            })]
          }, localProductLine);
        })
      })
    })]
  });
};

export default SuiteBusinessObjectives;